import { i18n } from "@lingui/core";
import * as Sentry from "@sentry/react";

import {
  getLocaleOrFallback,
  retryMessageCatalogImport,
} from "@readai/common/i18n";
import logger from "@readai/common/logger";

import { messages as enMessages } from "./en/messages";

/** Switch the current locale (dynamically imports messages catalog) */
export const switchLocale = async (locale: string) => {
  const localeToLoad = getLocaleOrFallback(locale);

  logger.info(
    `Loading ${localeToLoad} locale messages for user requested locale: ${locale}`,
  );

  const fallbackFn = () => {
    i18n.loadAndActivate({ locale: localeToLoad, messages: enMessages });
  };

  const importerFn = async () => {
    const { messages } = await import(`./${localeToLoad}/messages.po`);

    i18n.loadAndActivate({ locale: localeToLoad, messages });
  };

  const dynamicImportSucceeded = await retryMessageCatalogImport(
    localeToLoad,
    importerFn,
    fallbackFn,
  );

  if (!dynamicImportSucceeded) {
    Sentry.captureMessage(`Failed to load locale messages after max retries.`, {
      extra: { locale: localeToLoad },
    });
  }
};

export default i18n;
